import { instances } from '../default-setup';

//EmojisetLeakStatus
export const getEmoji = () => instances.get('settings/emojis/');

export const createEmoji = (data) => instances.post('settings/emojis/', data);

export const updateEmoji = (data) => instances.put('settings/emojis/', data);
